export interface SessionParticipant {
  id: number;
  firstName: string;
  lastName: string;
  birthDate: string;
  active: boolean;
}

export class Session {
  constructor(
    public readonly id: number | undefined,
    public readonly startDateTime: string,
    public readonly endDateTime: string,
    public readonly note: string,
    public readonly exported: boolean,
    public readonly active: boolean,
    public readonly dispositifId: number,
    public readonly dispositifName: string,
    public readonly activityId: number | null,
    public readonly activityName: string | null,
    public readonly userId: number | null,
    public readonly userUsername: string,
    public readonly lieuId: number | null,
    public readonly lieuNom: string | null,
    public readonly participants: SessionParticipant[],
  ) {}

  withActive(active: boolean): Session {
    return new Session(
      this.id,
      this.startDateTime,
      this.endDateTime,
      this.note,
      this.exported,
      active,
      this.dispositifId,
      this.dispositifName,
      this.activityId,
      this.activityName,
      this.userId,
      this.userUsername,
      this.lieuId,
      this.lieuNom,
      this.participants,
    );
  }
}
